import { isDefined } from '@sgme/fp';
import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedDate } from 'components/shared/Intl';
import { DateReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';

export interface ProductSummaryDateProps {
  node: DateReadonlyValueDefinition;
}

export const ProductSummaryDate: FC<ProductSummaryDateProps> = ({ node }) => {
  const data = useReadonlyField().getMetadataWithData(node);

  const translationKey = node.translationKey ?? node.id;

  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      <p className="text-large fw-light m-0" data-e2e={`product-summary-field-${node.id}`}>
        {isDefined(data) && <FormattedDate value={data} year="numeric" month="short" day="2-digit" />}
      </p>
    </SummaryFieldRow>
  );
};

ProductSummaryDate.displayName = 'ProductSummaryDate';
